<template>
  <div :class="['m-gotop-img',{'m-gotop-img--new': hasNew}]" @click="top"></div>
</template>

<script>
import {scrollTop} from '@/utils/index'
export default {
  data () {
    return {
      allId: 'all',
      eliteId: 'elite'
    }
  },
  methods: {
    top () {
      let self = this
      scrollTop(window, window.scrollY, 0, 500, function () {
        self.$store.dispatch('reload')
      })
    }
  },
  computed: {
    activeId () {
      return this.$store.state.list.activeId
    },
    hasNew () {
      return this.$store.state.list.hasNew
    }
  }
}
</script>



// WEBPACK FOOTER //
// goTop.vue?62980b34